import React from "react";
import * as ReactDOM from "react-dom";
import $ from "jquery";
import ProjectList from "./project-list.js";
import ProjectDetail from "./project-detail";

/**
 * Returns project category name if one exists
 * @return {null|string}
 */
function getCategory() {
  const $categoryName = $('[name="category-name"]');
  if ($categoryName.length) {
    return $categoryName.val();
  }
  return null;
}

$(() => {
  // we're either in a project details page(no react), or a project list(react).
  const projectListDomNode = document.getElementById(
    "portfolio-browser-wrapper"
  );

  if (projectListDomNode) {
    ReactDOM.render(
      <ProjectList category={getCategory()} />,
      projectListDomNode
    );
  } else if ($(".project-detail").length) {
    ProjectDetail.init();
  }
});
